import { Link } from 'react-router-dom';

export default function UseCasesSection() {
  return (
    <section className="sec" style={{ backgroundColor: "#FAFAFB" }}>
      <div className="wrap">
        <div className="hd2 rv">
          <div>
            <small>사내 지식 검색부터 반복 업무 자동화까지</small>
            <h2>
              다양한 업무에 활용하는
              {' '}
              <em>AI Agent</em>
            </h2>
          </div>
          <Link className="more" to="/product">
            자세히보기
            <svg className="i">
              <use href="#arr" />
            </svg>
          </Link>
        </div>
        <div className="mos">
          <div className="bc hasgo tall gp rv">
            <div className="t">
              <svg className="i">
                <use href="#search" />
              </svg>
              사내 지식 검색
            </div>
            <p>사규·매뉴얼·업무 문서 기반의 빠른 정보 검색과 응답</p>
            <div className="ill">
              <div className="flowq">
                <div className="ask">
                  휴가 신청은 어떻게 하나요?
                  <i>
                    <svg className="i">
                      <use href="#up" />
                    </svg>
                  </i>
                </div>
                <span className="stp">
                  <i style={{ background: "linear-gradient(135deg,#8F89FF,#EC4899)" }}>
                    <svg className="i">
                      <use href="#spark" />
                    </svg>
                  </i>
                  질문 분석 중
                </span>
                <span className="stp">
                  <i style={{ background: "var(--blu)" }}>
                    <svg className="i">
                      <use href="#search" />
                    </svg>
                  </i>
                  문서 검색 중
                </span>
                <div className="res ui grad">
                  <div className="hd3">
                    <span className="ico" style={{ background: "var(--pnk)", width: "26px", height: "26px", borderRadius: "8px" }}>
                      <svg className="i" style={{ width: "13px", height: "13px" }}>
                        <use href="#spark" />
                      </svg>
                    </span>
                    질문에서 시작하는 지식 검색
                    <em>
                      <svg className="i">
                        <use href="#edit" />
                      </svg>
                      <svg className="i">
                        <use href="#more" />
                      </svg>
                    </em>
                  </div>
                  <div className="bd3">
                    사내 규정에서 답변과 출처를 함께 확인
                    <div className="sk" style={{ width: "80%" }} />
                    <span className="srcc" style={{ marginTop: "4px" }}>
                      <svg className="i">
                        <use href="#doc" />
                      </svg>
                      출처 · 사내 업무 매뉴얼
                    </span>
                  </div>
                </div>
                <div className="res ui doc2">
                  <div className="doc">
                    <span className="fi">PDF</span>
                    <div>
                      <b>사내 업무 매뉴얼</b>
                      <span>관련 내용 보기</span>
                    </div>
                  </div>
                  <div className="pv">
                    <div>
                      <mark>휴가 신청</mark>
                      {' '}
                      절차 안내
                    </div>
                  </div>
                  <div className="rel">
                    <small>참고한 지식베이스</small>
                    <div className="rr">
                      <span className="dt" style={{ background: "var(--ac)" }} />
                      직무전결규정
                      <em>3 문서</em>
                    </div>
                    <div className="rr">
                      <span className="dt" style={{ background: "var(--blu)" }} />
                      매뉴얼
                      <em>1 문서</em>
                    </div>
                    <div className="rr">
                      <span className="dt" style={{ background: "var(--teal)" }} />
                      회사소개서
                      <em>1 문서</em>
                    </div>
                  </div>
                  <span className="cursor" style={{ right: "34px", top: "30px" }}>
                    <svg viewBox="0 0 22 22">
                      <use href="#ptr" />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="bc hasgo gm rv d1">
            <div className="t">
              <svg className="i">
                <use href="#users" />
              </svg>
              고객 문의 대응
            </div>
            <p>FAQ·제품 자료 기반의 고객 문의 응대 AI Agent 활용</p>
            <div className="ill">
              <div className="ui" style={{ left: "0", right: "0", top: "0" }}>
                <div className="uih" style={{ borderBottom: "1px solid var(--g1)" }}>
                  <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span className="ico" style={{ background: "var(--teal)", width: "26px", height: "26px" }}>
                      <svg className="i">
                        <use href="#msg" />
                      </svg>
                    </span>
                    <b>제품 FAQ · 이용 안내</b>
                  </span>
                  <span className="dt" style={{ background: "var(--grn)" }} />
                </div>
                <div style={{ padding: "14px 16px" }}>
                  <div style={{ background: "var(--g1)", borderRadius: "4px 14px 14px 14px", padding: "10px 12px", fontSize: "13px", lineHeight: "1.6", color: "var(--t2)", display: "inline-block" }}>
                    반복되는 문의에 필요한 정보를 안내
                  </div>
                </div>
                <div className="qr">
                  <span>제품 FAQ</span>
                  <span>이용 안내</span>
                </div>
              </div>
            </div>
          </div>
          <div className="bc hasgo gs rv d2">
            <div className="t">
              <svg className="i">
                <use href="#db" />
              </svg>
              업무 데이터 조회
            </div>
            <p>SQL 없이 자연어로 조회하는 사내 업무 데이터 활용 환경</p>
            <div className="ill">
              <div className="ask" style={{ left: "0", top: "0", fontSize: "13px", height: "44px", boxShadow: "0 0 0 2px #C7D9FB,0 10px 26px rgba(59,130,246,.15)" }}>
                이번 달 판매 현황을 보여줘
                <i style={{ background: "var(--blu)", width: "32px", height: "32px" }}>
                  <svg className="i">
                    <use href="#up" />
                  </svg>
                </i>
              </div>
              <div className="ui" style={{ left: "0", right: "0", top: "60px" }}>
                <div className="uih">
                  <b>질문을 통해 필요한 데이터 조회</b>
                  <span className="bdg b">Text-to-SQL</span>
                </div>
                <div className="tbl">
                  <div className="tr">
                    <span className="sk" />
                    <span className="bar" style={{ width: "86%" }} />
                    <span className="sk" />
                  </div>
                  <div className="tr">
                    <span className="sk" />
                    <span className="bar" style={{ width: "62%", opacity: ".7" }} />
                    <span className="sk" />
                  </div>
                  <div className="tr">
                    <span className="sk" />
                    <span className="bar" style={{ width: "44%", opacity: ".45" }} />
                    <span className="sk" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bc hasgo wide gpk rv">
            <div className="t">
              <svg className="i">
                <use href="#repeat" />
              </svg>
              업무 자동화
            </div>
            <p>조건·이벤트 기반 반복 업무 자동 실행과 워크플로우 연결</p>
            <div className="ill">
              <div className="mflow" style={{ left: "0", top: "0" }}>
                <span className="n">
                  <span className="ico" style={{ background: "var(--org)" }}>
                    <svg className="i">
                      <use href="#clock" />
                    </svg>
                  </span>
                  이벤트 감지
                </span>
                <span className="ln" />
                <span className="n">
                  <span className="ico" style={{ background: "#F97316" }}>
                    <svg className="i">
                      <use href="#branch" />
                    </svg>
                  </span>
                  조건 확인
                </span>
                <span className="ln" />
                <span className="n" style={{ boxShadow: "0 0 0 2px var(--ac),0 10px 24px rgba(115,108,227,.4)" }}>
                  <span className="ico" style={{ background: "var(--pnk)" }}>
                    <svg className="i">
                      <use href="#spark" />
                    </svg>
                  </span>
                  작업 실행
                </span>
              </div>
              <div className="ui log" style={{ left: "0", right: "0", top: "66px", color: "var(--ink)" }}>
                <div className="r2" style={{ border: "0" }}>
                  <span className="dt" style={{ background: "var(--grn)" }} />
                  <b>반복 업무를 하나의 흐름으로</b>
                  <span className="bdg g">성공</span>
                </div>
                <div className="r2">
                  <span className="dt" style={{ background: "var(--grn)" }} />
                  <b>Notion 신규 항목 → Gmail 알림</b>
                  <span className="bdg g">성공</span>
                </div>
                <div className="r2">
                  <span className="dt" style={{ background: "var(--org)" }} />
                  <b>DB 조회 자동 보고 메일</b>
                  <span className="bdg o">실행 중</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
